import { provideHttpClient, withInterceptors, withXhr } from '@angular/common/http';
import { ApplicationConfig, importProvidersFrom, LOCALE_ID } from '@angular/core';
import { LEXICON_FILE_FORMAT_OPTION, LexiconModule } from '@galaxy/lexicon';
import En from '../assets/i18n/en_devel.json';
import { authInterceptor } from './interceptors/auth.interceptor';
import { pageUrlInterceptor } from './interceptors/page-url.interceptor';
import { INBOX_CONFIG_FOR_CONVERSATION } from './config/inbox-config';
import { ConversationCoreModule } from '@galaxy/conversation/core';
import { inMemoryPersistence } from '@angular/fire/auth';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { GalaxySnackbarModule } from '@vendasta/galaxy/snackbar-service';
import { bootstrapI18n, GalaxyI18NModule, getLocale } from '@vendasta/galaxy/i18n';
import { MarkdownModule } from 'ngx-markdown';
import { ConversationUIModule } from '@galaxy/conversation/ui';
import { Language } from '@vendasta/galaxy/i18n';
import { registerLocaleData } from '@angular/common';
import localeFr from '@angular/common/locales/fr';
import localeFrCa from '@angular/common/locales/fr-CA';
import localeCs from '@angular/common/locales/cs';
import localePt from '@angular/common/locales/pt';
import localeNl from '@angular/common/locales/nl';
import localeDe from '@angular/common/locales/de';
import localeEs419 from '@angular/common/locales/es-419';
import localeRu from '@angular/common/locales/ru';
import localeAf from '@angular/common/locales/af';
import localeHe from '@angular/common/locales/he';
import localeIt from '@angular/common/locales/it';
import localeFrExtra from '@angular/common/locales/extra/fr';
import localeFrCaExtra from '@angular/common/locales/extra/fr-CA';
import localeCsExtra from '@angular/common/locales/extra/cs';
import localePtExtra from '@angular/common/locales/extra/pt';
import localeNlExtra from '@angular/common/locales/extra/nl';
import localeDeExtra from '@angular/common/locales/extra/de';
import localeEs419Extra from '@angular/common/locales/extra/es-419';
import localeRuExtras from '@angular/common/locales/extra/ru';
import localeAfExtras from '@angular/common/locales/extra/af';
import localeHeExtras from '@angular/common/locales/extra/he';
import localeItExtras from '@angular/common/locales/extra/it';
import { provideProtoTransport } from '@vendasta/protos';

const WEBLATE_COMPONENT_NAME = 'webchat/webchat-client';
const BASE_TRANSLATIONS = En;

registerLocaleData(localeFr, Language.FRENCH, localeFrExtra);
registerLocaleData(localeFrCa, Language.FRENCH_CANADA, localeFrCaExtra);
registerLocaleData(localeCs, Language.CZECH, localeCsExtra);
registerLocaleData(localePt, Language.PORTUGUESE, localePtExtra);
registerLocaleData(localeNl, Language.DUTCH, localeNlExtra);
registerLocaleData(localeDe, Language.GERMAN, localeDeExtra);
registerLocaleData(localeEs419, Language.SPANISH_LATIN_AMERICA, localeEs419Extra);
registerLocaleData(localeRu, Language.RUSSIAN, localeRuExtras);
registerLocaleData(localeAf, Language.AFRIKAANS, localeAfExtras);
registerLocaleData(localeHe, Language.HEBREW, localeHeExtras);
registerLocaleData(localeIt, Language.ITALIAN, localeItExtras);

const environment = globalThis.environment || 'prod';
bootstrapI18n(
  WEBLATE_COMPONENT_NAME,
  BASE_TRANSLATIONS,
  null,
  LEXICON_FILE_FORMAT_OPTION.NESTED_JSON,
  false,
  environment,
);

export const appConfig: ApplicationConfig = {
  providers: [
    provideProtoTransport(),
    provideHttpClient(withXhr(), withInterceptors([authInterceptor, pageUrlInterceptor])),
    importProvidersFrom(GalaxyI18NModule),
    importProvidersFrom(
      LexiconModule.forRoot({
        componentName: WEBLATE_COMPONENT_NAME,
        baseTranslation: BASE_TRANSLATIONS,
        disableOtw: false,
        defaultLanguage: getLocale(),
      }),
    ),
    importProvidersFrom(
      ConversationCoreModule.forRoot({
        config: INBOX_CONFIG_FOR_CONVERSATION,
        authPersistence: inMemoryPersistence,
      }),
    ),
    importProvidersFrom(MatSnackBarModule),
    importProvidersFrom(GalaxySnackbarModule),
    importProvidersFrom(ConversationUIModule),
    importProvidersFrom(MarkdownModule.forRoot()),
    {
      provide: LOCALE_ID,
      useValue: getLocale(),
    },
  ],
};
